<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Języki wolontariuszy</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-dialog v-model="dialog" max-width="500px">
			<v-btn slot="activator" color="primary" class="ml-3 mb-2">Dodaj język wolontariuszy</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja języka </span>
					<span class="headline" v-else> Dodaj nowy język </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-text-field v-model="editedItem.name"
									browser-autocomplete="off"
									v-on:click="discardDuplicateLanguageError"
									label="Język"
									aria-label="language name"
									for="volunteer-languages-view-language"
									id="volunteer-languages-view-language"
									@input="discardDuplicateLanguageError"
								></v-text-field>
							</v-flex>
							<div
								v-if="showDuplicateLanguageMessage"
								style="color:red;">
								Język {{ editedItem.name }} już istnieje w systemie.
							</div>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save">{{ isEdited ? "Zapisz" : "Utwórz"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<div>
			<v-btn @click="exportData" color="primary" dark class="ml-3 mb-2">eksportuj</v-btn>
		</div>
		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1"
		>
			<template slot="items" slot-scope="props">
				<td class="text-xs-left">{{ props.item.name }}</td>
				<td class="text-xs-left">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deleteItem(props.item)" >
								<v-icon v-on="on" color= "lightred">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "../../../api";
	import {ExportUtils} from "../../../utils/ExportUtils";
	import {VolunteerLanguage} from "../../../api/generated/VolunteerLanguage";

	export default {
		name: "VolunteerLanguagesView",
		watch: {

			"dataTable.pagination": {
				handler() {
					this.getItemList();
				},
				deep: true
			},

			dialog(val) {
				!val && (this.editedIndex = -1) && (this.editedItem = {});
				this.discardDuplicateLanguageError();
			},

		},

		computed: {
			pages() {
				// paginacja nie została zainicjalizowana
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},

			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		data() {
			return {
				dataTable: {
					searchFields: {},
					tableHeaders: [
						{
							text: "Język",
							sortable: true,
							value: "language"
						},
						{
							text: "Akcje",
							sortable: false,
						},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
					},
					search: "",
				},

				dialog: false,

				showDuplicateLanguageMessage: false,

				editedItem: {},

				editedIndex: -1,
			};
		},

		methods: {

			exportData () {
				let search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				let endpointMainPath = "volunteer-language";
				let path = "/" + endpointMainPath +
					"/export?search=" + search
					+ "&sort=" + sort;
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList() {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let sort = this.buildSort();
				Api.get(this,
					"/volunteer-language/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page +
						"&result=" + this.dataTable.pagination.rowsPerPage +
						"&sort=".concat(sort), response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
						});
			},

			resetSearch() {
				this.clearFields();
				this.getItemList();
			},

			clearFields() {
			},

			/* eslint-disable */
			buildSearch(searchFields) {
				let search = "";
				return search;
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			discardDuplicateLanguageError() {
				this.showDuplicateLanguageMessage = false;
			},

			editItem(item) {
				this.editedIndex = this.dataTable.itemList.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć język?", {
					icon: 'delete',
					title: 'Usuwanie języka wolontariuszy',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							const index = this.dataTable.itemList.indexOf(item);
							VolunteerLanguage.delete(this, item.id, successResponse => {
									this.dataTable.itemList.splice(index, 1);
									this.$messagesBus.$emit("success", "Język został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć języka", errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
			},

			save() {
				if (this.editedIndex > -1) {
					VolunteerLanguage.put(this, this.editedItem, successResponse => {
						Object.assign(this.dataTable.itemList[this.editedIndex], this.editedItem);
						this.close();
						this.$messagesBus.$emit("success", "Język został pomyślnie zapisany", successResponse);
					}, errorResponse => {
						this.showDuplicateLanguageMessage = true;
						this.$messagesBus.$emit("error", "Nie udało się zapisać języka", errorResponse);
					});
				} else {
					VolunteerLanguage.post(this, this.editedItem, successResponse => {
						this.editedItem.id = successResponse;
						this.dataTable.itemList.push(this.editedItem);
						this.close();
						this.$messagesBus.$emit("success", "Język został pomyślnie dodany", successResponse);
					}, errorResponse => {
						this.showDuplicateLanguageMessage = true;
						this.$messagesBus.$emit("error", "Nie udało się dodać języka", errorResponse);
					});
				}
			},
		},
	};
</script>

<style scoped>

</style>
